import DownloadIcon from '@mui/icons-material/Download';
import { useLang, uiText } from '../../../utils/i18n';

const SecondaryDropDownMenu = () => {
    const { lang } = useLang();

    const navs = [
        {
            title: uiText('downloadApp', lang),
            icon: <DownloadIcon sx={{ fontSize: "18px" }} />,
            redirect: "/download-app",
        },
    ]

    return (
        <div className="absolute w-60 -right-2 top-9 bg-white shadow-2xl rounded flex-col text-sm">

            {navs.map((item, i) => {

                const { title, icon, redirect } = item;

                return (
                    <a className="pl-3 py-3.5 border-b flex gap-3 items-center hover:bg-gray-50 rounded-t" href={redirect} key={i}>
                        <span className="text-primary-blue">{icon}</span>
                        {title}
                    </a>
                )
            })}

            <div className="absolute right-1/2 -top-2.5">
                <div className="arrow_down"></div>
            </div>
        </div>
    );
};

export default SecondaryDropDownMenu;
